function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFetchPackageLogoSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 488 488",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-166.667,-172.958)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer-1",
    serifId: "Layer 1",
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,98.49,41.51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-58.49,-58.489C-90.793,-58.489 -116.979,-32.302 -116.979,0C-116.979,32.303 -90.793,58.49 -58.49,58.49C-26.187,58.49 0,32.303 0,0C0,-32.302 -26.187,-58.489 -58.49,-58.489",
    style: {
      fill: "rgb(44,185,228)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.58868,-0.808366,-0.808366,0.58868,63.9659,84.6286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-28.68,6.453L4.299,6.453L5.643,12.875L-30.744,13.154L-28.68,6.453Z",
    style: {
      fill: "rgb(243,243,245)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.960717,-0.277531,-0.277531,-0.960717,139.066,102.789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.14,-2.309L5.955,-2.309L-17.442,8.38C-19.699,8.228 -21.619,8.308 -23.269,8.534L-1.14,-2.309Z",
    style: {
      fill: "rgb(243,243,245)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.984827,-0.173541,-0.173541,0.984827,97.1943,118.652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-38.039,-19.139L-0.727,-19.139L-1.136,0.275L-38.512,3.409L-38.039,-19.139Z",
    style: {
      fill: "rgb(243,243,245)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.152833,0.988252,0.988252,0.152833,151.255,115.569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-7.228,-13.349L14.763,-13.349L4.203,-5.818L-10.548,-6.196L-7.228,-13.349Z",
    style: {
      fill: "rgb(243,243,245)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,88.5625,92.3765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-6.333C-0.538,-4.143 1.123,-1.695 0.327,1.017C-1.046,5.695 -7.093,10.085 -9.308,11.007C-17.015,14.219 -19.65,0.496 -19.664,-4.889C-19.668,-6.684 -15.734,-11.595 -14.928,-11.603C-14.742,-11.604 -18.969,-6.617 -18.468,-3.774C-17.914,-0.628 -16.072,9.432 -11.963,9.089C-9.885,8.917 -3.678,5.544 -1.974,1.574C-0.665,-1.476 -1.963,-4.214 -1.229,-6.495C0.37,-11.464 2.229,-11.603 2.498,-11.603C3.648,-11.602 1.281,-11.545 0,-6.333M11.02,6.704L11.195,5.569L12.304,5.272C12.648,5.18 12.966,5.093 13.161,5.039L13.357,4.986C13.589,4.924 13.833,4.893 14.083,4.893C14.926,4.893 15.716,5.243 16.631,5.649C18.038,6.273 19.965,7.127 22.95,7.127C25.284,7.127 27.932,6.596 30.82,5.548L31.093,5.449C33.249,2.1 34.397,-1.301 33.87,-2.937C33.575,-3.85 32.269,-4.752 30.506,-5.606C26.375,-7.61 19.734,-9.356 17.722,-10.401C16.251,-11.166 15.208,-12.442 14.227,-14.474C12.418,-18.215 -4.952,-23.017 -8.421,-20.538C-15.612,-15.399 -22.734,-10.733 -30.275,-6.601L-13.29,16.684C-9.683,13.7 -4.155,9.959 3.395,10.261C5.762,10.356 7.916,11.874 9.931,13.747L11.02,6.704Z",
    style: {
      fill: "rgb(243,243,245)",
      fillRule: "nonzero"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFetchPackageLogoSm);
export default __webpack_public_path__ + "static/media/fetch-package-logo-sm.9838dae206e5c26d0858cb7c86dc341a.svg";
export { ForwardRef as ReactComponent };